import { type SpendProductSupplierRowDto } from 'entities/ReportSpendSummary';
import { toNumber } from 'shared/lib/number/number';
import { type ReportWidgetItem } from 'widgets/ComposableReportWidget';

export const mapProductSuppliersToWidgetItems = (
    suppliers: SpendProductSupplierRowDto[],
): ReportWidgetItem[] =>
    suppliers
        .map((supplier) => ({
            id: supplier.supplierId,
            label: supplier.supplierName,
            primaryValue: toNumber(supplier.totalSpend),
            secondaryValues: {
                label: supplier.supplierName,
                supplierSku: supplier.supplierSku ?? '',
                quantity: supplier.quantity,
                totalSpend: supplier.totalSpend,
                percentOfTotal: supplier.percentOfTotal,
            },
            meta: { supplierId: supplier.supplierId },
        }))
        .sort(
            (left, right) =>
                toNumber(right.primaryValue) - toNumber(left.primaryValue),
        );
